import { editorPrinciples, voiceQuotes } from "../../../mocks/starTracker";

export default function About() {
  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
            <i className="ri-community-line text-base"></i>
            关于我们
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            一个慢下来、把瓜看明白的地方
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            回声观察社是一家专注明星婚变等突发事件<b className="font-semibold text-foreground-800">后续进展追踪</b>的编辑型内容站。
            我们不抢“第一个发声”，而是等事件沉淀，把<b className="font-semibold text-foreground-800">离婚诉讼、公开回应、道歉、封杀塌房</b>
            等关键节点串成时间线，用传播、公关与信息核查的视角做复盘。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们相信，公众需要的不是被情绪点燃，而是被信息照亮。热闹会过去，理解会留下来。
          </p>

          <div className="mt-6 overflow-hidden rounded-lg bg-foreground-950 p-6">
            <div className="flex items-center gap-2 text-accent-300">
              <i className="ri-quote-text text-2xl"></i>
              <p className="font-heading text-lg font-bold text-background-50">四句话，是我们做内容的定盘星</p>
            </div>
            <ul className="mt-4 space-y-2.5">
              {editorPrinciples.map((p) => (
                <li key={p.title} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-500/25 text-accent-300">
                    <i className={`${p.icon} text-sm`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-background-50">{p.title}</p>
                    <p className="text-xs leading-relaxed text-background-300/80">{p.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {[
              { icon: "ri-scales-3-line", title: "诉讼程序线", desc: "离婚财产分割、抚养安排等程序性进展" },
              { icon: "ri-megaphone-line", title: "声明与回应线", desc: "当事人、工作室发声的时机与措辞" },
              { icon: "ri-emotion-line", title: "道歉与诚意线", desc: "道歉逻辑、事实厘清与补偿路径复盘" },
              { icon: "ri-prohibited-line", title: "商务与行业线", desc: "代言处理、节目排期等行业连锁反应" },
            ].map((c) => (
              <div key={c.title} className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${c.icon} text-lg`}></i>
                </span>
                <p className="mt-3 font-heading text-base font-bold text-foreground-950">{c.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-5 rounded-lg bg-background-50 p-6 ring-1 ring-background-200">
            <p className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-star-fill text-accent-500"></i>
              读者怎么说
            </p>
            <div className="mt-4 space-y-4">
              {voiceQuotes.map((q) => (
                <figure key={q.name} className="border-l-2 border-primary-400 pl-4">
                  <blockquote className="text-sm leading-relaxed text-foreground-700">“{q.text}”</blockquote>
                  <figcaption className="mt-1.5 text-xs text-secondary-500">— {q.name}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}